import React from 'react';
import {
  FiPlay,
  FiPause,
  FiFile,
  FiAlertTriangle,
  FiRefreshCw
} from 'react-icons/fi';

import type { WorkflowSummaryData } from '../../../services/analyticsService';

interface Props {
  workflowSummary: WorkflowSummaryData | null;
  isLoading: boolean;
  error: string | null;
  onRetry: () => void;
}

const ActiveWorkflowsWidget: React.FC<Props> = ({
  workflowSummary,
  isLoading,
  error,
  onRetry
}) => (
  <div className='dw-card'>
    <div className='dw-card__label'>Total Workflows</div>
    {isLoading ? (
      <>
        <div
          className='dw-skel'
          style={{
            height: 32,
            width: 56,
            borderRadius: 6,
            margin: '8px 0 4px'
          }}
        />
        <div
          className='dw-skel'
          style={{ height: 11, width: 110, borderRadius: 4, marginBottom: 12 }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            marginTop: 8
          }}
        >
          {[1, 2, 3].map(i => (
            <div
              key={i}
              className='dw-skel'
              style={{ height: 20, borderRadius: 4 }}
            />
          ))}
        </div>
      </>
    ) : error ? (
      <div className='mws-error'>
        <span className='mws-error__msg'>
          <FiAlertTriangle size={12} /> {error}
        </span>
        <button onClick={onRetry} className='mws-error__retry'>
          <FiRefreshCw size={10} /> Retry
        </button>
      </div>
    ) : (
      <>
        <div className='dw-card__hero' style={{ color: '#a200ff' }}>
          {workflowSummary?.total ?? 0}
        </div>
        <div className='dw-card__subtitle'>workflows configured</div>
        <div className='dw-summary' style={{ marginTop: 8 }}>
          <div className='dw-summary__row'>
            <span className='dw-summary__label mws-icon-label'>
              <FiPlay size={10} style={{ color: '#22c55e' }} /> Running
            </span>
            <span className='dw-summary__value dw-summary__value--success'>
              {workflowSummary?.running ?? 0}
            </span>
          </div>
          <div className='dw-summary__row'>
            <span className='dw-summary__label mws-icon-label'>
              <FiPause size={10} style={{ color: '#f59e0b' }} /> Stopped
            </span>
            <span className='dw-summary__value' style={{ color: '#f59e0b' }}>
              {workflowSummary?.stopped ?? 0}
            </span>
          </div>
          <div className='dw-summary__row'>
            <span className='dw-summary__label mws-icon-label'>
              <FiFile size={10} style={{ color: 'var(--text-tertiary)' }} />{' '}
              Draft
            </span>
            <span className='dw-summary__value'>
              {workflowSummary?.draft ?? 0}
            </span>
          </div>
        </div>
      </>
    )}
  </div>
);

export default ActiveWorkflowsWidget;
